import React, { useState, useContext } from "react";
import classes from "./Topbar.module.css";
import DarkModeContext from "../../store/DarkModeContext";
import AuthContext from "../../store/AuthContext";
import PopupContext from "../../store/PopupContext";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { CiDark } from "react-icons/ci";
import { AiOutlineSun } from "react-icons/ai";
import { AiFillLock } from "react-icons/ai";
import Backdrop from "../BackDrop/BackDrop";
import { PolicyComponent } from "../Policy/policy2";
import { GiHamburgerMenu } from "react-icons/gi";
function Topbar() {
  const darkModeCtx = useContext(DarkModeContext);
  const isDark = darkModeCtx.darkMode;
  const authCtx = useContext(AuthContext);
  const isAuth = authCtx.auth;
  const { popupIsOpened, togglePopup } = useContext(PopupContext);
  const location = useLocation();
  const isPaginaAlvo = location.pathname === "/";
  const [menuOpen, setMenuOpen] = useState(false);
  // Detecta se é mobile (ajuste conforme sua necessidade)
  const isMobile = window.innerWidth <= 768;
  const isLandscape = window.innerWidth > window.innerHeight;
  const handleDarkModeToggle = () => {
    darkModeCtx.toggleDarkMode();
  };
  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };
  const [tg, i18n] = useTranslation("global");
  const languageChangeHandler = (lang) => {
    i18n.changeLanguage(lang);
  };
  const handleLogout = () => {
    authCtx.authFalse();
  };
  const navigate = useNavigate();
  const gotologin = () => {
    navigate("/login");
  };
  // Fecha o menu ao clicar em qualquer link
  const handleMenuItemClick = () => {
    setMenuOpen(false);
  };
  return (
    <>
      <header
        id="topbar"
        className={isAuth === 2 ? classes.header : classes.header2}
        style={isPaginaAlvo ? { width: "100%", transform: "translateX(0%)" } : {}}
      >
        {/* Título sempre visível */}
        <span className={classes.logo}>{tg("global.header.title")}</span>
        {/* Botão hamburger para telemóveis */}
        <button className={classes.hamburger} onClick={toggleMenu} aria-label="Menu">
          <GiHamburgerMenu size={28} />
        </button>
        {/* Menu principal - aparece ou esconde conforme estado */}
        <nav className={`${classes.nav} ${menuOpen ? classes.navOpen : classes.navClosed}`}>
          {/* Popup dentro do sidebar no desktop */}
          {popupIsOpened && !isMobile && (
            <>
              <Backdrop cancel={togglePopup} />
              <div className="policy-wrapper">
                <PolicyComponent close={togglePopup} />
              </div>
            </>
          )}
          {/* Links do menu conforme auth */}
          {isAuth === 0 && (
            <ul className={classes.nav__list}>
              <li>
                <Link to="/" onClick={handleMenuItemClick}>
                  {tg("global.header.home")}
                </Link>
              </li>
              <li>
                <Link to="/liveMap" onClick={handleMenuItemClick}>
                  {tg("global.header.liveMap")}
                </Link>
              </li>
              <li>
                <a
                  href="https://forms.gle/cYTNCfrveWZhvXCUA"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleMenuItemClick}
                >
                  {tg("global.header.reports")}
                </a>
              </li>
              <li>
                <Link
                  to="#"
                  onClick={() => {
                    togglePopup();
                    setMenuOpen(false);
                  }}
                >
                  {tg("global.header.terms")}
                </Link>
              </li>
            </ul>
          )}
          {isAuth === 2 && (
            <ul className={classes.nav__list}>
              <li>
                <Link to="/" onClick={handleMenuItemClick}>
                  {tg("global.header.home")}
                </Link>
              </li>
              <li>
                <Link to="/objectives" onClick={handleMenuItemClick}>
                  {tg("global.header.objectives")}
                </Link>
              </li>
              <li>
                <Link to="/prize" onClick={handleMenuItemClick}>
                  {tg("global.header.prizes")}
                </Link>
              </li>
              <li>
                <Link to="/liveMap" onClick={handleMenuItemClick}>
                  {tg("global.header.liveMap")}
                </Link>
              </li>
              <li>
                <a
                  href="https://forms.gle/cYTNCfrveWZhvXCUA"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleMenuItemClick}
                >
                  {tg("global.header.reports")}
                </a>
              </li>
            </ul>
          )}
          {/* Botões e selects também dentro do menu */}
          <div className={classes.menuExtras}>
            {isAuth === 0 && (
              <button
                className={classes.private_mode_acess}
                onClick={() => {
                  gotologin();
                  setMenuOpen(false);
                }}
              >
                <AiFillLock size={35} />
              </button>
            )}
            <button
              className={classes.dark_mode_image_button_container}
              onClick={() => {
                handleDarkModeToggle();
                setMenuOpen(false);
              }}
            >
              {isDark ? <CiDark size={35} /> : <AiOutlineSun size={35} />}
            </button>
            <select
              className={classes.select_button}
              name="PreviousReceiver"
              onChange={(e) => {
                languageChangeHandler(e.target.value);
                setMenuOpen(false);
              }}
            >
              <option value="pt">Português</option>
              {/* outras línguas comentadas */}
            </select>
            {isAuth === 2 && (
              <button
                className={classes.logout_button}
                onClick={() => {
                  handleLogout();
                  setMenuOpen(false);
                }}
              >
                {tg("global.header.logout")}
              </button>
            )}
          </div>
        </nav>
      </header>
      {/* Popup centralizado no ecrã em mobile */}
      {popupIsOpened && isMobile && (
      <>
        <Backdrop cancel={togglePopup} />
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            zIndex: 2000,
            padding: "1rem 1.5rem",
            borderRadius: "8px",
            maxWidth: "295px",
            maxHeight: "80vh",
            overflowY: "auto",
            boxShadow: "0 0 10px rgba(0,0,0,0.3)",
            display: "flex",
            flexDirection: "column",
            width: "295px", // força a largura pra ocupar a maior parte da tela
            minHeight: "60vh", // garante uma altura mínima boa
          }}
        >
          <PolicyComponent close={togglePopup} />
        </div>
      </>
      )}
    </>
  );
}
export default Topbar;